module.exports = __webpack_public_path__ + "img/add-bank.e7ba6856.jpg";